import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import ReactPlayer from 'react-player'

export default class ReactComponent extends React.Component {

  render () {

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section">
            <div className="section-header">
              <PortfolioNextPrevLink data={data} />
              <h2>Description</h2>
            </div>
            <p>
              Mobile Reality Boxing is an Android augmented reality boxing game controlled by actual physical punches. Its goal is to persuade smart phone users to be more physically active through punching and jabbing. It is selected as one of the ten finalists in Thailand National Electronics and Computer Technology Center (NECTEC) National Software Contest in 2011.
            </p>
            <br />

            <p>
              The game is implemented in Android with OpenGL ES 2.0. It utilizes the phone’s accelerometer and compass to determine the orientation of the user and three-dimensional space in order to render the surrounding virtual environment accordingly. We have also implemented a punch recognizer by detecting large magnitude accelerator movements. In this implementation, the player fight against one computer player using real physical punch and prevent damage using the guard gesture.
            </p>
            <br />
          </div>

          <div className="section center">
            Demo Video
            <ReactPlayer url='https://www.youtube.com/watch?v=P3w_VJzHtd4' className="center-auto" controls="true"/>
          </div>
          
          <br/><br/>

          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>
                Decha Moungsri (AI Development)
              </li>
              <li>
                Soravis Prakkamakul (Graphics Development, UI Design, Game Assets)
              </li>
            </ul>
          </div>
          
          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>

        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/mobile-reality-boxing/index.js
 **/